import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    class: _vm.$style.mobileSteps,
    on: {
      "click": function click($event) {
        _vm.isShowMenu = !_vm.isShowMenu;
      }
    }
  }, [_c('div', {
    class: _vm.$style.mobileStep
  }, [_c('span', {
    class: _vm.$style.stepsLabel
  }, [_vm._v("\n        " + _vm._s(_vm.currentStep + 1) + " / " + _vm._s(_vm.steps.length) + "\n      ")]), _vm._v("\n      " + _vm._s(_vm.steps[_vm.currentStep].label) + "\n    ")])]), _vm._v(" "), _c('aside', {
    class: [_vm.$style.StepsPageSidebar, _defineProperty({}, _vm.$style.open, _vm.isShowMenu)]
  }, [_c('div', {
    class: _vm.$style.mobileTitle
  }, [_c('div', [_vm._v("\n        Меню опросника\n      ")]), _vm._v(" "), _c('SButton', {
    class: _vm.$style.closeButton,
    attrs: {
      "id": "drawer-close",
      "equal": "",
      "theme": "ghost"
    },
    on: {
      "click": function click($event) {
        _vm.isShowMenu = false;
      }
    }
  }, [_c('SIcon', {
    attrs: {
      "icon": "close",
      "size": "24"
    }
  })], 1)], 1), _vm._v(" "), _vm._t("header"), _vm._v(" "), _c('transition-group', {
    class: _vm.$style.steps,
    attrs: {
      "name": "list",
      "tag": "ul",
      "appear": ""
    }
  }, [_vm._t("steps", function () {
    return _vm._l(_vm.steps, function (step, idx) {
      return _c('li', {
        key: step.label,
        class: _vm.$style.step
      }, [_c('Step', _vm._b({
        attrs: {
          "index": idx,
          "type": _vm.checkingStep(idx)
        }
      }, 'Step', step, false))], 1);
    });
  })], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm._t("footer")], 2)], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };